<template lang="html">
    <div id="page__services__toolbar" style="flex-grow: 3" class="report-forward-search tollbar__search">
        <div class="text">
            <span> Для печати отчёта укажите параметры фильтрации </span>
        </div>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset"  v-bind:disabled="!hasFilter"></z-icon-button>
        <z-icon-button v-bind:icon="['fa', 'gear']" rounded v-on:click="toggleFilter" primary-light  v-bind:disabled="!hasFilter"></z-icon-button>
        <div v-if="visibility" v-click-outside="hideFilter" class="md-elevation-2 dropdown">
            <div class="search-md-menu-container">
                <div class="filter-container md-layout">

                    <div class="center-layout md-size-20 md-layout-item"> <label> Дата от </label> </div>
                    <div class="center-layout with-pr center-layout md-size-80 md-layout-item">
                        <z-date v-model="filter.date_from" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата от"> </z-date>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item"> <label> Дата до </label> </div>
                    <div class="center-layout with-pr center-layout md-size-80 md-layout-item">
                        <z-date v-model="filter.date_to" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата до"> </z-date>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item"> <label> Услуги </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <multy-autocomplete
                            placeholder="Услуги" id="report_filter_service_ids" name="report_filter_service_ids"
                            display-property="label" property="value" return="value"
                            v-model="filter.service_ids" v-bind:items="services"
                            v-bind:showOnFocus="true" v-bind:show-search-input="false"
                        ></multy-autocomplete>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item">
                        <label> Город отправления </label>
                    </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <multy-autocomplete
                            placeholder="Город (введите город)" id="report_filter_city_from_ids" name="report_filter_city_from_ids"
                            display-property="label" property="value" return="value"
                            v-model="filter.city_from_ids" v-bind:callback="getCities"
                            v-bind:showOnFocus="true" v-bind:show-search-input="true" v-bind:clear-after-select="true"
                        ></multy-autocomplete>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item">
                        <label> Город назначения </label>
                    </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <multy-autocomplete
                            placeholder="Город (введите город)" id="report_filter_city_to_ids" name="report_filter_city_to_ids"
                            display-property="label" property="value" return="value"
                            v-model="filter.city_to_ids" v-bind:callback="getCities"
                            v-bind:showOnFocus="true" v-bind:show-search-input="true" v-bind:clear-after-select="true"
                        ></multy-autocomplete>
                    </div>                    

                    <div class="center-layout md-size-20 md-layout-item">
                        <label> Город<br>(отправление или назначение) </label>
                    </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <multy-autocomplete
                            placeholder="Город (введите город)" id="report_filter_city_ids" name="report_filter_city_ids"
                            display-property="label" property="value" return="value"
                            v-model="filter.city_ids" v-bind:callback="getCities"
                            v-bind:showOnFocus="true" v-bind:show-search-input="true" v-bind:clear-after-select="true"
                        ></multy-autocomplete>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item"> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <z-check label="Все города (фильтр по городу будет игнорироваться)" id="report_filter_city_all" v-model="filter.city_all" v-bind:value="1"> </z-check>
                    </div>

                    <div class="center-layout md-size-20 md-layout-item"> <label> Исполнитель </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <z-select v-model="filter.executor_id">
                            <option value="" selected> Любой </option>
                            <option
                                v-for="company in companies"
                                v-bind:value="company.id"
                                v-bind:key="`filter-executor-${company.id}`"
                            >{{ `${company.name} (НДС ${company.nds_value}%)` }}</option>
                        </z-select>
                    </div>

                    <div class="dropdown-button-container md-alignment-bottom-right md-size-100 md-layout-item">
                        <z-button v-on:click="doFilter" fit-content no-margin> Применить </z-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ZSelect from '@/components/ZSelect'
    import ClickOutside from 'vue-click-outside'
    import ZDate from '@/components/ZDate'
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    import MultyAutocomplete from '@/components/MultyAutocomplete';
    import ZCheck from '@/components/ZCheck';
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZButton from '@/components/ZButton.vue';
    export default {
        components: {ZSelect, ZDate, MultyAutocomplete, ZInputAutocomplete, ZCheck, ZButton, ZIconButton },
        directives: {ClickOutside},
        data() {
            return {
                visibility: false,
                users: [],
                services: [],
                filter: {
                    date_from: null,
                    date_to: null,
                    city_all: 0,
                    city_ids: [],
                    city_from_ids: [],
                    city_to_ids: [],
                    service_ids: [],
                    nds: null,
                    executor_id: null,
                },
                filterDefault: {
                    date_from: null,
                    date_to: null,
                    city_all: 0,
                    city_ids: [],
                    city_from_ids: [],
                    city_to_ids: [],
                    service_ids: [],
                    nds: null,
                    executor_id: null,
                },
            }
        },
        created() {
            this.init();
            if (this.$route.query && this.$route.query.custom_filter) this.filter = Object.assign({}, JSON.parse(this.$route.query.custom_filter));
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).find(item => !!item);
            },
            companies() {
                return this.$store.state.companies.companies;
            },
        },
        methods: { 
            /**
             * Инициализация компонента
             */
            init() {
                this.filter.date_from = this.moment().tz(this.$root.userTimezone).subtract(1,'months').startOf('month').toDate();
                this.filter.date_to   = this.moment().tz(this.$root.userTimezone).subtract(1,'months').endOf('month').toDate();
                this.getServices();
                this.doFilter();
                this.getCompanies();
            },
            /**
             * Скрыть фильтр
             */
            hideFilter() {
                this.visibility = false;
            },
            /**
             * Переключение фильтра
             */
            toggleFilter() {
                this.visibility = !this.visibility;
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                this.init();
                this.doFilter();
                return;
            },
            /**
            * Применение фильтра
            */
            doFilter() {
                this.$nextTick(() => {
                    let query = Object.assign({}, this.$route.query);
                    if (!query) query = {};
                    query.custom_filter = JSON.stringify(Object.assign({}, this.filter));
                    this.$router.push({ name: this.$route.name, params: this.$route.params, query: query});
                    this.$root.$emit('refresh-table', 'report-services');
                    this.hideFilter();
                });
            },
            /**
             * Получение услуг
             */
            getServices(section) {
                this.services = Object.assign([], []);
                let params = {
                    order_by: 'sort',
                    filter: (section) ?
                        {model: [['section','=',section],'and',['active','=','1']], relation: []} :
                        {model: [['active','=','1']], relation: []}
                };
                return this.$store.dispatch('deals/getFreigtsServices', params).then(services => {
                    return this.resolveServices(services);
                });
            },
            /**
             * Подставление услуг
             */
            resolveServices(services) {
                this.services = Object.assign([], services.map(item => {
                    return {label: item.name, value: item.id, id: item.id}
                }));

                this.services.push({
                    id:    'extra--doom_make',
                    label: 'Изготовление обрешётки',
                    value: 'extra--doom_make',
                });

                this.services.push({
                    id:    'entity--doom',
                    label: 'Обрешётка',
                    value: 'entity--doom',
                });

                return this.services;
            },
            /**
             * Получение городов
             */
            getCities(value) {
                if (!value || value.length < 3) return new Promise(resolve => resolve([]));
                let filter = {model: [['name', '%', value]]};
                return this.$store.dispatch('cost/getCitiesNew', {page: 1, order_by: 'name', order_type: 'asc', count: 20, filter: filter}).then(result => {
                    if (!result || !result.data) return [];
                    return result.data.map(city => {
                        return {id: city.id, value: city.id, label: city.name};
                    });
                });
            },
            getCompanies() {
                return this.$store.dispatch('companies/getCompanies', { cache: true });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// ServicesToolbar.vue?9a5ce65c